import { render, staticRenderFns } from "./TheNotification.vue?vue&type=template&id=d63158fa&scoped=true"
import script from "./TheNotification.vue?vue&type=script&lang=js"
export * from "./TheNotification.vue?vue&type=script&lang=js"
import style0 from "./TheNotification.vue?vue&type=style&index=0&id=d63158fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63158fa",
  null
  
)

export default component.exports